import type { FC, ReactNode } from "react";

import { cn } from "@/components/podkit/lib/cn";

export type CrossfadeIndex = 0 | 1;

type CrossfadeIconProps = {
    /** The two icon elements to cross-fade between */
    icons: [ReactNode, ReactNode];
    /** Index of the currently active icon */
    activeIndex: CrossfadeIndex;
    className?: string;
};

/**
 * Cross-fades between icon elements using the same opacity + scale + blur
 * transition pattern as the sidebar logo/toggle in SidebarLogoToggle.
 */
export const CrossfadeIcon: FC<CrossfadeIconProps> = ({ icons, activeIndex, className }) => {
    return (
        <div className={cn("relative size-8", className)}>
            <div
                className={cn(
                    "pointer-events-none absolute inset-0 flex items-center justify-center transition-all duration-300",
                    activeIndex === 0 ? "scale-100 opacity-100 blur-none" : "scale-50 opacity-0 blur-sm",
                )}
                aria-hidden={activeIndex !== 0}
            >
                {icons[0]}
            </div>
            <div
                className={cn(
                    "pointer-events-none absolute inset-0 flex items-center justify-center transition-all duration-300",
                    activeIndex === 1 ? "scale-100 opacity-100 blur-none" : "scale-50 opacity-0 blur-sm",
                )}
                aria-hidden={activeIndex !== 1}
            >
                {icons[1]}
            </div>
        </div>
    );
};
